import { isStandaloneDisplay } from "./pushNotifications";

/** First-launch prompt flow finished (Später, enabled, or blocked). */
export const STANDALONE_FIRST_LAUNCH_KEY = "albis-standalone-first-launch-v1";
export const PUSH_PROMPT_DISMISSED_KEY = "albis-push-prompt-dismissed";
export const PUSH_RESUME_AFTER_LOGIN_KEY = "albis-push-resume-after-login";

export function isPushPromptDismissed() {
  try {
    return localStorage.getItem(PUSH_PROMPT_DISMISSED_KEY) === "1";
  } catch {
    return false;
  }
}

/** User finished the first-launch prompt (dismiss, enabled, or OS denied). */
export function markStandaloneFirstLaunchComplete() {
  try {
    localStorage.setItem(STANDALONE_FIRST_LAUNCH_KEY, String(Date.now()));
    localStorage.setItem(PUSH_PROMPT_DISMISSED_KEY, "1");
    localStorage.removeItem(PUSH_RESUME_AFTER_LOGIN_KEY);
  } catch {
    /* ignore */
  }
}

export function dismissPushPrompt() {
  markStandaloneFirstLaunchComplete();
}

export function setPushResumeAfterLogin() {
  try {
    localStorage.setItem(PUSH_RESUME_AFTER_LOGIN_KEY, "1");
  } catch {
    /* ignore */
  }
}

export function isPushResumeAfterLogin() {
  try {
    return localStorage.getItem(PUSH_RESUME_AFTER_LOGIN_KEY) === "1";
  } catch {
    return false;
  }
}

export function clearPushResumeAfterLogin() {
  try {
    localStorage.removeItem(PUSH_RESUME_AFTER_LOGIN_KEY);
  } catch {
    /* ignore */
  }
}

/** First home-screen launch: prompt not completed yet. */
export function isFirstStandalonePromptPending() {
  if (!isStandaloneDisplay()) return false;
  try {
    return !localStorage.getItem(STANDALONE_FIRST_LAUNCH_KEY);
  } catch {
    return false;
  }
}

/**
 * @returns {boolean} Show the first-launch prompt (first open or after login from prompt).
 */
export function shouldOfferStandalonePushPrompt() {
  if (!isStandaloneDisplay() || isPushPromptDismissed()) return false;
  if (isPushResumeAfterLogin()) return true;
  return isFirstStandalonePromptPending();
}
